import { log } from './debug';
import { triggerPathAndQuery } from './matchElementPathAndDomain';

export function initConversions(context) {
  (context.config.channelEvents || []).forEach((event) => {
    const trackConversion = () => {
      if (event.amountFunction) {
        try {
          const amount = eval(event.amountFunction);
          context.trackConversion(event._id, amount);
          return;
        } catch (err) {
          log.debug(err);
        }
      }
      context.trackConversion(event._id);
    };

    if (event && event._id) {
      if (event.triggerType === 'path' && event.triggerPath && triggerPathAndQuery(event.triggerPath)) {
        trackConversion();
      } else if (event.triggerType === 'function' && event.triggerFunction) {
        try {
          const trigger = !!eval(event.triggerFunction);
          if (trigger) {
            trackConversion();
          }
        } catch (err) {
          log.debug(err);
        }
      } else if (event.triggerType === 'selector' && event.triggerSelector) {
        const triggerElements = document.querySelectorAll(event.triggerSelector);
        for (let triggerElementIndex = 0; triggerElementIndex < triggerElements.length; triggerElementIndex += 1) {
          const triggerElement = triggerElements[triggerElementIndex];
          if (triggerElement) {
            triggerElement.addEventListener('click', () => {
              trackConversion();
            }, true);
          }
        }
      }
    }
  });
}
